<template>
  <div class="dashboard-container">
    <div
      v-if="loading"
      class="progress-bar"
      :style="{ width: progress + '%' }"
    ></div>
    <div class="mb-2 page-title">
      <i class="bi bi-geo"></i> Gelanggang
    </div>

    <div class="mb-3 d-flex flex-wrap gap-2 justify-content-between align-items-start">
      <DataToolbar
        v-model="searchQuery"
        placeholder="Cari gelanggang atau turnamen..."
        :mencari="loading"
        @search="cari"
      >
        <template #filters>
          <!--
            Turnamen yang sudah selesai disembunyikan secara bawaan.
            Datanya tidak dihapus - hanya tidak ikut ditampilkan, supaya
            daftar tidak dipenuhi acara tahun-tahun sebelumnya.
          -->
          <label class="saring-selesai">
            <input type="checkbox" v-model="termasukSelesai" @change="cari(searchQuery)" />
            Tampilkan turnamen selesai
          </label>
        </template>
      </DataToolbar>

      <router-link to="/admin/tournament-arena/create" class="button button-primary">
        <i class="bi bi-plus-square"></i> Tambah
      </router-link>
    </div>

    <!-- Modal Konfirmasi Hapus -->
    <div class="modal fade" id="confirmDeleteModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Konfirmasi Hapus</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            Apakah Anda yakin ingin menghapus gelanggang <strong>{{ selectedArenaName }}</strong>?
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Batal</button>
            <button type="button" class="btn btn-danger" :disabled="deleting" @click="deleteArena">
              <span v-if="deleting" class="spinner-border spinner-border-sm me-1"></span>
              Ya, Hapus
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Table to display navigation data -->
    <div class="table-responsive mt-3">
      <table class="table mb-0">
        <thead>
          <tr>
            <th>No</th>
            <th>Turnamen</th>
            <th>Arena Name</th>
            <th>Aksi</th>
          </tr>
        </thead>
        <!-- Wrapper element with v-if -->
        <tbody v-if="tournamentArenas.length > 0">  
          <tr v-for="(tournamentArena, index) in tournamentArenas" :key="tournamentArena.id">
            <td>{{ index + 1 + (currentPage - 1) * perPage }}</td>
            <td class="kolom-turnamen">{{ tournamentArena.tournament?.name || '-' }}</td>
            <td>{{ tournamentArena.name }}</td>
            
            <td class="action-column">
              <div class="d-flex gap-2 justify-content-end">
          <MenuAksi v-slot="{ tutup }">
            <button type="button" class="aksi__item"
                    @click="tutup(); EditArena(tournamentArena.id)">
              <i class="bi bi-pencil-square"></i> Ubah
            </button>
            <button type="button" class="aksi__item aksi__item--bahaya"
                    @click="tutup(); confirmDelete(tournamentArena)">
              <i class="bi bi-trash"></i> Hapus
            </button>
          </MenuAksi>
        </div>
            </td>
          </tr>
        </tbody>
        <!-- Fallback message when there is no data -->
        <tbody v-else>
          <tr>
            <td colspan="7" class="text-center">Belum ada data.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination Controls -->
    <div class="d-flex justify-content-end mt-4">
      <AppPagination
        :current-page="currentPage"
        :total-pages="totalPages"
        :prev-page-url="prevPageUrl"
        :next-page-url="nextPageUrl"
        @change-page="changePage"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import API from "@/config/api";
import DataToolbar from "@/components/ui/DataToolbar.vue";
import MenuAksi from "@/components/ui/MenuAksi.vue";
import AppPagination from "@/components/ui/AppPagination.vue";
import { Modal } from "bootstrap";
import { useToast } from "vue-toastification";

axios.defaults.baseURL = API.API_BASE_URL;

export default {
  name: "TournamentArenaList",

  components: { DataToolbar, MenuAksi, AppPagination },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      tournamentArenas: [], // Array to hold paginated team members
      searchQuery: "",
      // Bawaan false: turnamen selesai disembunyikan.
      termasukSelesai: false,
      currentPage: 1, // Current page of results
      perPage: 10, // Results per page
      totalPages: 0, // Total number of pages
      prevPageUrl: null, // URL of the previous page
      nextPageUrl: null, // URL of the next page
      loading: false,
      progress: 0,
      selectedArenaId: null,
      selectedArenaName: "",
      deleteModal: null,
      deleting: false,
    };
  },
  mounted() {
    this.loadTournamentArenas(); // Load menu data when the component is mounted
    const modalEl = document.getElementById("confirmDeleteModal");
    if (modalEl) {
      this.deleteModal = new Modal(modalEl);
    }
  },
  methods: {
    /** Dipanggil DataToolbar setelah pengguna berhenti mengetik (350 ms). */
    cari(kata) {
      this.searchQuery = kata ?? '';
      this.currentPage = 1;
      this.loadTournamentArenas(1);
    },

    async loadTournamentArenas(page = 1) {
      this.loading = true;
      try {
        const response = await axios.get("/tournament-arenas", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`, // Assumes token is in localStorage
          },
          params: {
            page,
            perPage: this.perPage,
            search: this.searchQuery.trim(),
            termasuk_selesai: this.termasukSelesai ? 1 : 0,
          },
        });
        const {
          current_page,
          last_page,
          data,
          next_page_url,
          prev_page_url,
        } = response.data;

        this.tournamentArenas = data; // Assign team members
        this.currentPage = current_page; // Current page
        this.totalPages = last_page; // Total pages
        this.nextPageUrl = next_page_url; // Next page URL
        this.prevPageUrl = prev_page_url; // Previous page URL
        this.loading = false;
      } catch (error) {
        console.error("Error loading data:", error);
        this.loading = false;
      }
    },

    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.loadTournamentArenas(page);
      }
    },

    searchClasses() {
      this.currentPage = 1; // Reset to page 1 for new search
      this.loadTournamentArenas();
    },

    async EditArena(id) {
      this.$router.push({ name: "EditArena", params: { id } });
    },

    confirmDelete(arena) {
      this.selectedArenaId = arena.id;
      this.selectedArenaName = arena.name || "Gelanggang";
      if (this.deleteModal) {
        this.deleteModal.show();
      }
    },

    async deleteArena() {
      if (!this.selectedArenaId) return;
      this.deleting = true;
      try {
        const response = await axios.delete(`/tournament-arenas/${this.selectedArenaId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        });
        if (this.deleteModal) this.deleteModal.hide();
        this.toast.success(response.data?.message || "Gelanggang berhasil dihapus.");
        this.loadTournamentArenas(this.currentPage);
      } catch (error) {
        if (this.deleteModal) this.deleteModal.hide();
        const pesan =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Gagal menghapus gelanggang.";
        this.toast.error(pesan);
        console.error("Gagal menghapus arena:", error);
      } finally {
        this.deleting = false;
      }
    },
  },
  computed: {
    prevPageExists() {
      return this.currentPage > 1;
    },
    nextPageExists() {
      return this.currentPage < this.totalPages;
    },
  },
};
</script>

<style scoped>
.saring-selesai {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  font-size: var(--text-sm);
  color: var(--text-secondary);
  white-space: nowrap;
  cursor: pointer;
}

.saring-selesai input { width: 16px; height: 16px; accent-color: var(--accent); }


.table th,
.table td {
  padding: 10px;
}






.form-control {
  width: 250px;
}

.progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 5px;
  background: var(--grad-flame);
  animation: loader-animation 1.5s infinite;
}

/* Animasi garis loader */
@keyframes loader-animation {
  0% {
    width: 0;
    background: var(--grad-flame); /* Warna awal */
  }
  50% {
    width: 50%;
    background: var(--grad-flame); /* Warna saat animasi */
  }
  100% {
    width: 100%;
    background: var(--grad-flame);
  }
}
</style>
